<div class="button-group">
    <button (click)="actionEvent.emit('Save')" [disabled]="formState==='Submitting'"
            class="button-group-button save"
            mat-flat-button>
            <span class="button-group-button save content">
              <app-component-loading [size]="'inline'" [margin]="0"
                                     *ngIf="formState==='Submitting'"></app-component-loading>
                {{ saveLabel|translate }}

            </span>
    </button>
    <button (click)="actionEvent.emit('Cancel')" [disabled]="formState==='Submitting'"
            class="button-group-button cancel"
            mat-flat-button>
        {{ 'WIDGETS.CANCEL'|translate }}
    </button>
</div>